import * as React from "react";
import { Portal } from "../../Portal/Portal/Portal.js";
import { DrawerBackdrop } from "../components/DrawerBackdrop/Drawer/components/DrawerBackdrop/DrawerBackdrop.js";
import { DrawerCloseButton } from "../components/DrawerCloseButton/Drawer/components/DrawerCloseButton/DrawerCloseButton.js";
import { DrawerContent } from "../components/DrawerContent/Drawer/components/DrawerContent/DrawerContent.js";
import { DrawerDivider } from "../components/DrawerDivider/Drawer/components/DrawerDivider/DrawerDivider.js";
import { DrawerHeader } from "../components/DrawerHeader/Drawer/components/DrawerHeader/DrawerHeader.js";
import { DrawerOverlay } from "../components/DrawerOverlay/Drawer/components/DrawerOverlay/DrawerOverlay.js";
import { DrawerTitle } from "../components/DrawerTitle/Drawer/components/DrawerTitle/DrawerTitle.js";
import { DrawerProvider } from "../context/Drawer/context/DrawerContext.js";
const Drawer = ({
  children,
  onClose,
  direction,
  open,
  onOpenChange,
  defaultOpen = false
}) => {
  const [internalOpen, setInternalOpen] = React.useState(defaultOpen);
  const isControlled = open !== void 0;
  const isOpen = isControlled ? open : internalOpen;
  const setIsOpen = React.useCallback(
    (value) => {
      const newValue = typeof value === "function" ? value(isOpen) : value;
      if (!isControlled) {
        setInternalOpen(newValue);
      }
      onOpenChange?.(newValue);
    },
    [isControlled, isOpen, onOpenChange]
  );
  return /* @__PURE__ */ React.createElement(DrawerProvider, { direction, isOpen, setIsOpen, onClose }, children);
};
Drawer.Overlay = DrawerOverlay;
Drawer.Backdrop = DrawerBackdrop;
Drawer.Portal = Portal;
Drawer.Header = DrawerHeader;
Drawer.Content = DrawerContent;
Drawer.Divider = DrawerDivider;
Drawer.Title = DrawerTitle;
Drawer.CloseButton = DrawerCloseButton;
export {
  Drawer as default
};
//# sourceMappingURL=Drawer.js.map
